import {SxProps, Theme} from '@mui/material';
import theme from 'src/theme';

export const wrapperSx: SxProps<Theme> = {
    padding: theme.spacing(0, 20 / 8, 20 / 8),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(10 / 8),
};
